import { User } from '@/api/generatedApi';
import { useDeleteUser } from '@/hooks/api/users/useDeleteUser';
import { DeleteModal } from './DeleteModal';

export const DeleteUserModal = ({
  isOpen,
  onClose,
  user,
  onSuccess,
}: {
  isOpen: boolean;
  onClose: () => void;
  user?: User;
  onSuccess?: (deletedUser: User) => void;
}) => {
  return (
    user?.id && (
      <DeleteModal
        title='Delete User'
        isOpen={isOpen}
        onClose={onClose}
        useHook={useDeleteUser}
        mutateParams={user.id}
        item={user}
        itemName={user.email}
        onConfirm={() => onSuccess?.(user)}
      />
    )
  );
};
